import { ITCFVendor } from "types/tcf";
import type { ITCFConsent } from "../TCFConsentProvider/types";

const isTCFVendorAccepted = (
  vendor: ITCFVendor,
  consent: ITCFConsent,
): boolean => {
  return !!consent.vendors[vendor.id];
};

export default isTCFVendorAccepted;
